<script>
	import { Button, Col, Row } from "sveltestrap";
	import { form, field } from "svelte-forms";
	import { required } from "svelte-forms/validators";
	import Select from "svelte-select";
	import ErrorMessageHandler from "../../components/ErrorMessageHandler/ErrorMessageHandler.svelte";
	import Loader from "../../components/Loader/Loader.svelte";
	import PageHeader from "../../components/PageHeader/PageHeader.svelte";
	import client from "../../services/client";
	import { errorMessage, loading, carparkDetail } from "../../store/store";
	import SveltyPicker from "svelty-picker";
	import { navigate } from "svelte-routing";
	import { filedrop } from "filedrop-svelte";
	import { extractErrorMessage } from "src/utils/misc";
	import { onMount } from "svelte";
	import { getMasterData } from "src/services/profile";
	import CustomInput from "../../components/CustomInput/CustomInput.svelte";
	import CustomSelect from "../../components/CustomSelect/CustomSelect.svelte";

	export let isEdit;

	let files;
	let preview = [];
	let options = {
		accept: "image/*",
	};
	let selectedAddress = "0";
	let imageError = false;
	let carParkOwnerOptions = [];

	let carParkId = field("carParkId", "", [required()]);
	let description = field("description", "", [required()]);
	let activeFrom = field("activeFrom", "", [required()]);
	let activeTo = field("activeTo", "", [required()]);
	let carParkOwnerId = field("carParkOwnerId", "", [required()]);
	let address = field("address", "", [required()]);
	let latitude = field("latitude", "", []);
	let longitude = field("longitude", "", []);
	let postalCode = field("postalCode", "", []);
	let carParkImages = field("carParkImages", [], []);

	async function getCarParkOwnerOptions() {
		try {
			const {
				data: { carParkOwners },
			} = await getMasterData();
			carParkOwnerOptions = carParkOwners;
		} catch (err) {
			extractErrorMessage(err);
		}
	}

	onMount(() => {
		if (isEdit) {
			$carParkId.value = $carparkDetail.carParkId;
			$description.value = $carparkDetail.description;
			$activeFrom.value = $carparkDetail.activeFrom;
			$activeTo.value = $carparkDetail.activeTo;
			$carParkOwnerId.value = $carparkDetail.carParkOwnerId;
			$address.value = $carparkDetail.address;
			$latitude.value = $carparkDetail.latitude;
			$longitude.value = $carparkDetail.longitude;
			$postalCode.value = $carparkDetail.postalCode;
			$carParkImages.value = $carparkDetail.carParkImages;
		}
		getCarParkOwnerOptions();
	});

	const myForm = form(
		carParkId,
		description,
		activeFrom,
		activeTo,
		carParkOwnerId,
		address,
		latitude,
		longitude,
		postalCode,
		carParkImages
	);

	let duplicatecarparkId;
	let isImageEmty = "0";
	async function handleSubmit() {
		if (selectedAddress == "0") {
			selectedAddress = "";
		}

		if (!files) {
			isImageEmty = "";
		}

		let file = [];
		if (files) {
			for (let index = 0; index < files.accepted.length; index++) {
				files.accepted[index].url = preview[index];
				file.push({
					fileName: files.accepted[index].name,
					fileContentType: files.accepted[index].type,
					fileData: files.accepted[index].url,
				});
			}
		}

		try {
			const data = {
				name: $carParkId.value,
				description: $description.value,
				postalCode: $postalCode.value,
				activeFrom: new Date($activeFrom.value),
				activeTo: new Date($activeTo.value),
				carParkOwnerId: $carParkOwnerId.value,
				address: $address.value.value,
				carParkImages: $carParkImages.value || [],
				longitude: $longitude.value,
				latitude: $latitude.value,
			};
			if (isEdit) {
				data.id = isEdit;
			}
			const res = await client("/v1/carParks", {
				method: isEdit ? "PUT" : "POST",
				version: "Vehicle",
				data,
			});

			if (res.status === 200) {
				if (isEdit) {
					navigate(`/carpark-management/details/${res.data.id}`);
				} else {
					navigate("/carpark-management");
				}
			}

			loading.set(false);
		} catch (error) {
			loading.set(false);
			extractErrorMessage(error);
		}
	}

	const onFileSelected = (e) => {
		imageError = false;
		files = e.detail.files;

		let reader;
		for (let index = 0; index < files.accepted.length; index++) {
			reader = new FileReader();
			if (files.accepted[index].size > 2000000) {
				imageError = true;
				return;
			}
			if (files) {
				reader.readAsDataURL(files.accepted[index]);
				reader.onload = (e) => {
					$carParkImages.value = [
						...$carParkImages.value,
						{
							fileName: files.accepted[index].name,
							fileData: e.target.result,
							fileContentType: "image/png",
						},
					];
				};
			}
		}
	};

	const handleRemove = (i) => {
		let arr = $carParkImages.value.filter((val, index) => index !== i);
		$carParkImages.value = arr;
	};

	let load = false;
	loading.subscribe((value) => {
		load = value;
	});

	let err;
	errorMessage.subscribe((value) => {
		err = value;
	});

	const loadOptions = (filterText) => {
		filterText = filterText ? filterText.replace(" ", "_") : "";

		return new Promise((resolve, reject) => {
			const xhr = new XMLHttpRequest();
			xhr.open(
				"GET",
				`https://www.onemap.gov.sg/api/common/elastic/search?searchVal=${filterText}&returnGeom=Y&getAddrDetails=Y`
			);
			xhr.send();

			xhr.onload = () => {
				if (xhr.status >= 200 && xhr.status < 300) {
					setTimeout(
						resolve(
							JSON.parse(xhr.responseText).results.map((item) => {
								return {
									value: item.ADDRESS,
									label: item.ADDRESS,
									postal: item.POSTAL,
									longitude: item.LONGITUDE,
									latitude: item.LATITUDE,
								};
							})
						),
						2000
					);
				} else {
					reject();
				}
			};
		});
	};

	function handleSelect(event) {
		selectedAddress = event.detail.value;
		$longitude.value = event.detail.longitude || $carparkDetail.longitude;
		$latitude.value = event.detail.latitude || $carparkDetail.latitude;
		$postalCode.value = event.detail.postal || $carparkDetail.postalCode;
	}
</script>

<Row>
	<Col>
		<Col xs={6}>
			<ErrorMessageHandler message={err} />
		</Col>
		<div>
			<PageHeader title={isEdit ? "Edit carpark" : "Add new carpark"} />
			<Col>
				<Row>
					<Col>
						<label for="mandatory" class="d-block mb-3">
							<span>*Mandatory fields</span>
						</label>
					</Col>
				</Row>
				<Row>
					<Col>
						<label for="carParkId" class="d-block">
							<span> <b>Carpark ID*</b> </span>
						</label>
					</Col>
				</Row>
				<Row>
					<Col xs={2}>
						<CustomInput
							type="text"
							bind:value={$carParkId.value}
							error={$myForm.hasError("carParkId.required") ||
								duplicatecarparkId}
							errorText="Car park id is required"
						/>
					</Col>
				</Row>
			</Col>
			<Col>
				<Row>
					<Col>
						<label for="priority" class="d-block mt-3">
							<span> <b>Address*</b></span>
						</label>
					</Col>
				</Row>
				<Row>
					<Col xs={6}>
						<Select
							{loadOptions}
							containerClasses="form-select getgo select"
							id="food"
							hasError={$myForm.hasError("address.required")}
							on:select={handleSelect}
							placeholder="Input postal here.."
							bind:value={$address.value}
						/>

						{#if $myForm.hasError("address.required")}
							<div>
								<p class="error-text">Address is required</p>
							</div>
						{/if}
					</Col>
				</Row>
			</Col>

			<Col>
				<Row>
					<Col>
						<label for="description" class="d-block mt-3">
							<span> <b>Description*</b> </span>
						</label>
					</Col>
				</Row>
				<Row>
					<Col xs={6}>
						<CustomInput
							type="text"
							bind:value={$description.value}
							error={$myForm.hasError("description.required") ||
								$myForm.hasError("description.min") ||
								$myForm.hasError("description.max")}
							errorText={$myForm.hasError("description.required")
								? "Description is required"
								: $myForm.hasError("description.min")
								? "Minimum 4 characters"
								: $myForm.hasError("description.max")
								? "Maximum 25 characters"
								: ""}
						/>
					</Col>
				</Row>
			</Col>

			<Col>
				<Row>
					<Col>
						<label for="carparkOwner" class="d-block mt-3">
							<span> <b>Car park Owner*</b> </span>
						</label>
					</Col>
				</Row>
				<Row>
					<Col xs={6}>
						<CustomSelect
							bind:options={carParkOwnerOptions}
							type="text"
							bind:value={$carParkOwnerId.value}
							error={$myForm.hasError("carParkOwnerId.required")}
							errorText="Carpark owner is required"
							defaultOption="Select carpark owner"
						/>
					</Col>
				</Row>
			</Col><Col>
				<Row>
					<Col>
						<label for="carparkOwner" class="d-block mt-3">
							<span> <b>Car park Image</b> </span>
						</label>
					</Col>
				</Row>
				<Row>
					<Col>
						<label for="carparkOwner" class="d-block">
							<span>Type: PNG or JPG / Size: less than 2MB </span>
						</label>
					</Col>
				</Row>
				<Row>
					<Col xs={2} md={2} class={` ${imageError && "error"}`}>
						<div
							use:filedrop={options}
							on:filedrop={(e) => onFileSelected(e)}
							class={`filedrop ${imageError && "error"}`}
						>
							<svg
								xmlns="http://www.w3.org/2000/svg"
								viewBox="0 0 24 24"
								width="48"
								height="48"
								><path fill="none" d="M0 0h24v24H0z" /><path
									d="M1 14.5a6.496 6.496 0 0 1 3.064-5.519 8.001 8.001 0 0 1 15.872 0 6.5 6.5 0 0 1-2.936 12L7 21c-3.356-.274-6-3.078-6-6.5zm15.848 4.487a4.5 4.5 0 0 0 2.03-8.309l-.807-.503-.12-.942a6.001 6.001 0 0 0-11.903 0l-.12.942-.805.503a4.5 4.5 0 0 0 2.029 8.309l.173.013h9.35l.173-.013zM13 13v4h-2v-4H8l4-5 4 5h-3z"
								/></svg
							>
							<p>Upload photos</p>
						</div>
						{#if imageError}
							<div>
								<p class="error-text">
									Image is larger than 2MB
								</p>
							</div>
						{/if}
					</Col>
				</Row>
				<Row>
					<Col xs={6} md={6}>
						<Col xs={12}>
							<div class="">
								{#each $carParkImages.value as val, i}
									<div class="container-checkbox me-2 my-2">
										<img
											src={val.fileUrl || val.fileData}
											style="width:100%; height:200px; object-fit: cover;"
											alt="carparkimg"
										/>
										<img
											class="close"
											src="https://img.icons8.com/fluency/48/000000/delete-forever.png"
											on:keydown={() => {}}
											on:click={() => handleRemove(i)}
											alt="delete-forever.png"
										/>
									</div>
								{/each}
							</div>
						</Col>
					</Col>
				</Row>
			</Col>

			<Col>
				<Row>
					<Col xs={2}>
						<label for="lastServicedate" class="d-block mt-3">
							<span> <b>Start Date*</b> </span>
						</label>
					</Col>
					<Col xs={2}>
						<label for="lastCleaned" class="d-block mt-3">
							<span> <b>End Date*</b> </span>
						</label>
					</Col>
				</Row>
				<Row>
					<Col xs={2}>
						<SveltyPicker
							inputClasses="form-control getgo input {$myForm.hasError(
								'activeFrom.required'
							)
								? 'border border-danger'
								: ''}"
							format="yyyy-mm-dd"
							placeholder="YYYY-MM-DD"
							bind:value={$activeFrom.value}
							on:change={$activeFrom.validate}
						/>
						{#if $myForm.hasError("activeFrom.required")}
							<div>
								<p class="error-text">Start date is required</p>
							</div>
						{/if}
					</Col>
					<Col xs={2}>
						<SveltyPicker
							inputClasses="form-control getgo input {$myForm.hasError(
								'activeTo.required'
							)
								? 'border border-danger'
								: ''}"
							format="yyyy-mm-dd"
							placeholder="YYYY-MM-DD"
							bind:value={$activeTo.value}
							on:change={$activeTo.validate}
						/>
						{#if $myForm.hasError("activeTo.required")}
							<div>
								<p class="error-text">End date is required</p>
							</div>
						{/if}
					</Col>
				</Row>
			</Col>

			<Row>
				<Col class="d-flex justify-content-end gap-3">
					<Button class="themeButton" on:click={() => myForm.reset()}
						>Reset</Button
					>
					<!-- svelte-ignore a11y-no-noninteractive-tabindex -->
					<span
						class="d-inline-block"
						tabindex="0"
						data-bs-toggle={!$myForm.valid ? "tooltip" : ""}
						title={!$myForm.valid ? "Fill all required field" : ""}
					>
						<Button
							class="themeButton primary"
							on:click={() => handleSubmit()}
							on:click={$myForm.validate}
							disabled={!$myForm.valid ||
								!$carParkId.value ||
								!$description.value ||
								!$activeFrom.value ||
								!$activeTo.value ||
								!$carParkOwnerId.value ||
								!$address.value ||
								!$latitude.value ||
								!$longitude.value ||
								!$postalCode.value}
						>
							{#if load}
								<Loader />
							{:else if isEdit}
								Update
							{:else}
								Create
							{/if}
						</Button>
					</span>
				</Col>
			</Row>
		</div>
	</Col>
</Row>

<style>
	.filedrop {
		background-color: #f0f0f0;
		height: 100px;
		width: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		border-radius: 0.375rem;
		border: 0.7em dashed #c3c3c3;
		outline: 1em solid #f0f0f0;
		transition: border 0.3s ease-in-out;
		outline-offset: -1.3em;
		padding: 0.475em;
	}
	.filedrop:focus {
		border-color: #2196f3;
	}
	.filedrop:hover {
		border-color: #343434;
	}
	.filedrop p,
	.filedrop svg {
		transition: color 0.1s;
		transition: fill 0.1s;
	}
	.filedrop:focus p,
	.filedrop:focus svg {
		color: #2196f3;
		fill: #2196f3;
	}
	.filedrop:hover p,
	.filedrop:hover svg {
		color: #343434;
		fill: #343434;
	}

	.container-checkbox {
		position: relative;
		width: 30.3%;
		float: left;
	}

	.container-checkbox .close {
		display: block;
		width: 25px;
		height: 25px;
		position: absolute;
		top: 3px;
		right: 2px;
		overflow: hidden;
		text-indent: -9999px;
		cursor: pointer;
	}
	.filedrop.error:focus {
		border: 0.7em dashed red;
	}
</style>
